module.exports = __webpack_public_path__ + "cb6519a1d6d14840c5ed235f4b34ee8e.MP3";